import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { k8sMonthlyPriceColumnDef } from "./common/k8sMonthlyPriceColumnDef";
import { k8sClusterColumnDef } from "./common/k8sClusterColumnDef";
import { k8sLabelsColumnDef } from "./common/k8sLabelsColumnDef";
import { MoneyCellRenderer } from "../column-def-cell-renderers/money/MoneyCellRenderer";
import { FilteredKubernetesReplicaSetResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";

export const k8sReplicaSetColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("ReplicaSet Name"),

  k8sMonthlyPriceColumnDef,

  k8sClusterColumnDef,

  { field: "resource.namespace", headerName: "Namespace" },

  {
    field: "resource.cpu_monthly_cost",
    headerName: "CPU cost",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredKubernetesReplicaSetResourceItem>) => {
      return <MoneyCellRenderer money={data?.resource?.cpu_monthly_cost} />;
    },
  },

  k8sLabelsColumnDef,
];
